// Kickoff times are entered in 15-minute increments only (no free-typed
// minutes) — a coach picks from a fixed list instead of a native minute
// spinner, so every scheduled time lands on :00/:15/:30/:45.
export const TIME_OPTIONS = Array.from({ length: 96 }, (_, i) => {
  const totalMinutes = i * 15;
  const h24 = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  const value = `${String(h24).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
  const h12 = h24 % 12 === 0 ? 12 : h24 % 12;
  const period = h24 < 12 ? "AM" : "PM";
  const label = `${h12}:${String(m).padStart(2, "0")} ${period}`;
  return { value, label };
});

// Legacy games may have been saved with an off-grid minute (e.g. before this
// feature existed) — round to the nearest 15-minute mark so the <select>
// always has a matching option to show.
export function snapTo15(hhmm) {
  if (!hhmm) return "09:00";
  const [h, m] = hhmm.split(":").map(Number);
  const total = h * 60 + m;
  const snapped = (Math.round(total / 15) * 15) % 1440;
  const hh = Math.floor(snapped / 60);
  const mm = snapped % 60;
  return `${String(hh).padStart(2, "0")}:${String(mm).padStart(2, "0")}`;
}
